export default __webpack_public_path__ + "static/media/Illustration1.301e60d3.png";